import Cookies from 'js-cookie'
import authService from '../../services/auth/AuthService'

export const authModule = {
  namespaced: true,
  state: {
    user: null,
    loading: false,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    CLEAR_AUTH(state) {
      state.user = null
    },
  },
  actions: {
    async login({ commit }, credentials) {
      commit('SET_LOADING', true)
      try {
        const user = await authService.login(credentials)
        commit('SET_USER', user)
        return user
      } catch (err) {
        commit('CLEAR_AUTH')
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },
    setUserInfo({ commit }, payload) {
      commit('SET_USER', payload)
    },
    async logout({ commit }) {
      commit('SET_LOADING', true)
      try {
        await authService.logout()
        commit('CLEAR_AUTH')
      } catch (err) {
        commit('CLEAR_AUTH')
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
  getters: {
    user: (state) => state.user,
    loading: (state) => state.loading,
  },
}
